var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00292969H513V341.99H0V-0.00292969Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00292969H513V113.994H0V-0.00292969ZM0 227.993H513V341.99H0V227.993Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.083 197.015V179.172H292.186V155.38L280.291 143.485L268.396 155.38V131.59L256.5 119.694L244.604 131.59V155.38L232.709 143.485L220.813 155.38V179.172H208.917V197.015H197.022V214.858H315.978V197.015H304.083Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00683594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKh);
export default __webpack_public_path__ + "static/media/KH.a11421d9e02547e5eb42f3a3749d7308.svg";
export { ForwardRef as ReactComponent };